import "./hero.css";

const Hero = ({ pageTitle, pageDiscription }) => {
  return (
    <section id="hero" className="d-flex align-items-center">
      <div className="container">
        <h1>{pageTitle}</h1>
        <h2>{pageDiscription}</h2>
      </div>
    </section>
  );
};

export default Hero;
